import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=cd5568a6"
import script from "./blackList.vue?vue&type=script&lang=js"
export * from "./blackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports